import Auto_Weekend from "../wiki/guides/Auto_Weekend";
import Billionaire_Kuralinne from "../wiki/guides/Billionaire_Kuralinne";
import Boss_Card_Collection from "../wiki/guides/Boss_Card_Collection";
import Creature_Toggle from "../wiki/guides/Creature_Toggle";
import Devildom from "../wiki/guides/Devildom";
import Dungeon_Levels from "../wiki/guides/Dungeon_Levels";
import Dungeon_Time_Attack from "../wiki/guides/Dungeon_Time_Attack";
import Final_Awakening from "../wiki/guides/Final_Awakening";
import Guild_Zone from "../wiki/guides/Guild_Zone";
import How_to_Get_Arcanium from "../wiki/guides/How_to_Get_Arcanium";
import Item_Upgrade_Ancient_Steel from "../wiki/guides/Item_Upgrade_Ancient_Steel";
import Lak_Storage_System from "../wiki/guides/Lak_Storage_System";
import Monster_Kill_Rewards from "../wiki/guides/Monster_Kill_Rewards";
import Races_Quest from "../wiki/guides/Races_Quest";
import Rupee_Donations from "../wiki/guides/Rupee_Donations";
import Siege_Battles from "../wiki/guides/Siege_Battles";
import Signs_of_forgotten_gods from "../wiki/guides/Signs_of_forgotten_gods";
import Taming_Rate from "../wiki/guides/Taming_Rate";
import Treasure_Goblin from "../wiki/guides/Treasure_Goblin";
import Unidentified_Cloak from "../wiki/guides/Unidentified_Cloak";
import Worldboss_Positions from "../wiki/guides/Worldboss_Positions";

const wikiData = {
  "Guides": {
    "Auto Weekend Event": Auto_Weekend,
    "Races Buffs": Races_Quest,
    "Monster Kill Rewards": Monster_Kill_Rewards,
    "Treasure Goblin": Treasure_Goblin,
    "Unidentified Cloak": Unidentified_Cloak,
    "Worldboss Positions": Worldboss_Positions,
    "Guild Zone": Guild_Zone,
    "How to Get Arcanium": How_to_Get_Arcanium,
    "Rupee Donations": Rupee_Donations,
    "Siege Battles": Siege_Battles,
    "Billionaire Kuralinne": Billionaire_Kuralinne,
    "Boss Card Collection": Boss_Card_Collection,
    "Creature Toggle": Creature_Toggle,
    "Devildom": Devildom,
    "Dungeon Levels & Access": Dungeon_Levels,
    "Dungeon Time Attack": Dungeon_Time_Attack,
    "Final Awakening": Final_Awakening,
    "Item Upgrade Ancient Steel": Item_Upgrade_Ancient_Steel,
    "Lak Storage System": Lak_Storage_System,
    "Signs of Forgotten Gods": Signs_of_forgotten_gods,
    "Taming Rate": Taming_Rate,
  },
  "Introduction": {
    "About Rappelz": "Rappelz is a fantasy MMORPG known for its pet system and deep character customization.",
    "Getting Started": "To start playing Rappelz, download the client, create an account, and choose a server.",
    "How to Play?": "You will now learn the basics of the game which will allow you to start your adventure.",
    "Community": "Join our Discord and forums to stay up-to-date and interact with other players.",
    "Trainee Island Guide": "Trainee Island serves as the starting zone where new players learn basic mechanics.",
    "Newsletter": "Subscribe to our newsletter to get updates about events and new content."
  },
  "The Pets": {
    "Evolve Pets": "Pets can evolve into stronger versions with new abilities.",
    "How To Tame": "Use taming cards on monsters to capture them as pets.",
    "Looting Pets": "Certain pets help you pick up loot automatically.",
    "Pet Combination": "Combine pets to create unique effects and stronger companions.",
    "Pet Farm": "Manage a farm where you can level up and train multiple pets.",
    "Pet Equipment": "Equip your pets with gear to enhance their abilities.",
    "Soul Taming": "Special pets require soul taming for enhanced strength.",
    "Bestiary": "A collection of all available pets and their attributes.",
    "Boss Taming": "Rare bosses can be tamed but require special strategies."
  },
  "The World": {
    "Bear Dungeon": "A dungeon filled with fierce bears and high-level loot.",
    "Dungeons": "Explore different dungeons filled with enemies and treasure.",
    "Hidden Village": "A secret location where rare NPCs and shops exist.",
    "Market": "The central place for trading and selling items.",
    "NPCs": "Various NPCs provide quests, items, and information.",
    "Cities": "Major cities serve as hubs for players to interact and trade.",
    "Navis Lamia": "A dangerous area home to high-level enemies.",
    "Crystal Valley": "A beautiful yet deadly region with unique monsters.",
    "Sanctuary": "A mystical place where players can meditate and train.",
    "Temple of the Ancients": "An ancient ruin full of secrets and strong enemies.",
    "Temple of the Exile": "A challenging dungeon requiring teamwork to complete.",
    "Cubric": "A mysterious place with hidden rewards.",
    "Underground Dungeons": "Secret underground areas full of high-tier monsters."
  },
  "PvP System": {
    "Death Match": "A free-for-all mode where the last player standing wins.",
    "Duels": "Challenge other players to 1v1 battles.",
    "GvG": "Guild versus Guild battles for supremacy.",
    "PK Morality": "A system that tracks player-killing behavior.",
    "Arenas": "Special PvP zones where structured battles take place."
  },
  "The Items": {
    "Accessories": "Various rings, amulets, and trinkets that boost stats.",
    "Durability": "Items lose durability over time and need repair.",
    "Enhancement": "Upgrade weapons and armor for better stats.",
    "The Mounts": "Different mounts help with travel and provide bonuses.",
    "Skill Cards": "Boost specific skills with equippable cards.",
    "Boss Cards": "Rare cards dropped from bosses that grant unique abilities."
  },
  "Character": {
    "Character Stats": "Learn about different attributes and how they affect your character.",
    "Races & Jobs": "Choose from various races and classes with unique playstyles.",
    "Project 150": "A special questline available for high-level players.",
    "Daily Quests": "Repeatable quests that give rewards.",
    "Character Levels": "Understand the leveling system and max level progression."
  }
};

export default wikiData;
